import { getField, updateField } from 'vuex-map-fields'
import getWorkflowInstanceFiltersModel from './models/workflowInstanceFilters'

const workflowInstanceFilters = {
  namespaced: true,
  state: {
    ...getWorkflowInstanceFiltersModel()
  },
  getters: {
    getField,
    getSearchObject (state) {
      return state
    }
  },
  actions: {
    clearFilters ({ commit }) {
      return commit('clearFilters')
    }
  },
  mutations: {
    updateField,
    clearFilters (state) {
      state.statusId = null
    }
  }
}

export default workflowInstanceFilters
